import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { configureAmplify } from './lib/amplifyConfig';
import './styles/globals.css';

// Initialize Amplify before rendering
configureAmplify();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
